const API_ROOT = import.meta.env.VITE_API_URL || "/api";

export class ApiError extends Error {
  constructor(public readonly code: string, message: string, public readonly action?: string, public readonly status?: number) {
    super(message);
  }
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(`${API_ROOT}${path}`, {
    ...options,
    credentials: "include",
    headers: { "Content-Type": "application/json", "x-client-contract-version": "1", ...(options.headers ?? {}) },
  });
  if (response.status === 204) return undefined as T;
  const body = (await response.json().catch(() => null)) as
    | { code?: string; message?: string; action?: string; error?: { code?: string; message?: string; action?: string } }
    | T
    | null;
  if (!response.ok) {
    const failure = body as { code?: string; message?: string; action?: string; error?: { code?: string; message?: string; action?: string } } | null;
    const error = failure?.error;
    throw new ApiError(
      error?.code ?? failure?.code ?? "REQUEST_FAILED",
      error?.message ?? failure?.message ?? "请求未能完成",
      error?.action ?? failure?.action,
      response.status,
    );
  }
  return body as T;
}

export const post = <T>(path: string, body?: unknown) => api<T>(path, body === undefined ? { method: "POST" } : { method: "POST", body: JSON.stringify(body) });
export const patch = <T>(path: string, body: unknown) => api<T>(path, { method: "PATCH", body: JSON.stringify(body) });
export const put = <T>(path: string, body: unknown) => api<T>(path, { method: "PUT", body: JSON.stringify(body) });
export const remove = <T>(path: string) => api<T>(path, { method: "DELETE" });
